export const GIFT_CARDS_ENABLED = "GIFT_CARDS_ENABLED";

export const giftCardsEnabled = gift_cards_enabled => {
  return {
    type: GIFT_CARDS_ENABLED,
    value: gift_cards_enabled
  };
};



// WEBPACK FOOTER //
// ./src/actions/giftCards.js